class Monitoring.Models.ReviewQueueDefinition extends Backbone.Model
  urlRoot: '/monitoring/review_queue_definitions'

  defaults: ->
    name: ''
    priority: 1
    supervision: false
    active: true
    reverse_order: false
    granted_entities: # of type: RelatedUsersConnector.rb
      user_ids: []
      users_group_ids: []
    social_content_condition: # TODO
      topics: []
      tags: []
      groups: []
      sentiments: []
      subtypes: []
      ownership: 'all-content'
      authors: []
      excluded_authors: []
      moderation_statuses: []
      keywords: {}
      locations: []
      mentions: []
      min_followers: null
      news_sources: []
      intelligent_filter: @_emptyIntelligentFilter()

  _emptyIntelligentFilter: ->
    {
      intelligent_tags: {
        main_tags: [],
        secondary_tags: [],
        excluded_tags: [],
        main_tags_logic: 'OR',
        secondary_tags_logic: 'OR',
        excluded_tags_logic: 'OR'
      },
      intelligent_groups: {
        main_groups: [],
        secondary_groups: [],
        excluded_groups: [],
        main_groups_logic: 'OR',
        secondary_groups_logic: 'OR',
        excluded_groups_logic: 'OR'
      }
    }

  # TODO: Crear clase social_content_condition.js y poner estos métodos ahí
  validateFields: ->
    min_followers = @get('social_content_condition').min_followers
    unless min_followers == null or min_followers == '' or (min_followers + "").match(/^\d+$/)
      return I18n.t('monitoring.rules.validations.invalid_followers')
    @validateLengthOfStrings()

  validateLengthOfStrings: ->
    stringFields = [
      'topics',
      'tags',
      'groups',
      'subtypes',
      'authors',
      'excluded_authors',
      'mentions',
      'news_sources',
      'locations'
    ]

    ret = "VALID"

    _.each(stringFields, (field) =>
      string = @get('social_content_condition')[field].join(', ')
      if string.length > 2000
        translationKey = "monitoring.arrival_alerts.fields.#{field}"
        ret = "#{I18n.t('monitoring.arrival_alerts.validations.too_many')} #{I18n.t(translationKey)}!"
    )

    return ret

  isEmail: (string) ->
    string.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

  getTopicIdsAsIntegers: ->
    _.map(@get('social_content_condition').topics, (id) -> parseInt(id))


class Monitoring.Collections.ReviewQueueDefinitionsCollection extends Backbone.Collection
  model: Monitoring.Models.ReviewQueueDefinition
